import React from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'

import Spacer from '~/components/Spacer'
import FormError from '~/components/Form/ErrorText'
import PhoneInput from '~/components/Form/PhoneInput'
import InputTitle from './InputTitle'
import constants from '~/style/constants'
import * as PhoneNumberTools from '~/utilities/phoneNumber'
import * as StringTools from '~/utilities/string'
import useInject from '~/hooks/useInject'

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`

const mapStore = (store) => ({
  validateDisplayMessage: store.divorceLookup.validateDisplayMessage,
  phoneNumber: store.divorceLookup.phoneNumber,
  changeKey: store.divorceLookup.changeKey,
})

const PhoneNumber = () => {
  const { validateDisplayMessage, phoneNumber, changeKey } = useInject(mapStore)

  const handleChange = (event) => {
    const rawInput = event.target.value
    const digitInput = StringTools.removeNonDigits(rawInput)
    changeKey('phoneNumber', digitInput)
  }

  const phoneNumberErrorHandler = validateDisplayMessage('phoneNumber')

  return (
    <Wrap>
      <InputTitle>
        Phone Number
        <Spacer direction="width" mobile={11} desktop={11} />
      </InputTitle>
      <Spacer desktop={16} mobile={16} />
      <PhoneInput
        placeholder="(555) 555-5555"
        onChange={handleChange}
        value={PhoneNumberTools.AsYouTypeFormatter(phoneNumber)}
        altBorderColor={constants.colors.ui.borderGray}
        height="70px"
        boxShadow
        avenirNextRegular
        error={phoneNumberErrorHandler}
        marginBottom="2rem"
        maxLength={14}
      />
      <FormError error={phoneNumberErrorHandler} />
    </Wrap>
  )
}

export default observer(PhoneNumber)
